import {Navigate, Outlet} from 'react-router-dom';
import {useIsAuthenticated} from '@azure/msal-react';

const PrivateRoutes = () => {
    const isAuthenticated = useIsAuthenticated();

    return isAuthenticated
        ? <Outlet/>
        : <Navigate to="/login"/>;
};

export default PrivateRoutes;